import { TeamDetailed } from "core/models/Tournament";
import VsIcon from "shared/icons/VsIcon";
import avatar2 from "../../../assets/icons/avatar1.jpeg";
import CheveronLeftBold from "shared/icons/CheveronLeftBold";
import { useHistory } from "react-router-dom";

interface TournamentChatHeaderProps {
  teamsDetailed: TeamDetailed[];
  teamIdToClass: Record<string, "team-a" | "team-b">;
}

export default function TournamentChatHeader({
  teamsDetailed,
  teamIdToClass,
}: TournamentChatHeaderProps) {
  
  const history = useHistory();
  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div className={"tournament-chat-conatainer"}>
      <div onClick={handleBackClick} className="back-button">
        <CheveronLeftBold fontSize={16} />
      </div>
      <div className={"tournament-chat-wrapper"}>
        {teamsDetailed?.map((team: any, index: number) => (
          <>
            <div key={team.name} className={"tournament-chat-team"}>
              <img
                src={team.profileImg || avatar2}
                alt=""
                className={"tournament-chat-image"}
              />
              <h4
                className={`${"tournament-chat-text"} ${
                  teamIdToClass[team.teamId] ? teamIdToClass[team.teamId] : ""
                }`}
              >
                {team.teamName}
              </h4>
            </div>
            {index === 0 && (
              <div key={team.name}>
                {/* Insert VS icon after the first team */}
                <div className={"vs-icon-wrapper"}>
                  <VsIcon width={15} height={28} />
                </div>
              </div>
            )}
          </>
        ))}
      </div>
    </div>
  );
}
